import { isXSide } from './Side';
import { canWallSegmentGetObjectType } from '../Rules/canWallSegmentGetObjectType';
import { GLASS_ELEMENT, WALL_LIGHTBAND } from '../../Constants/ObjectTypes';

export function findNextFreeIndexForFixedSegmentObject(warehouseConfiguration, object) {
  const { side, index: sourceIndex, type } = object;
  const { xWallSegmentCount, zWallSegmentCount } = warehouseConfiguration;
  const segmentCount = isXSide(object.side) ? xWallSegmentCount : zWallSegmentCount;
  for (let indexAfter = sourceIndex + 1; indexAfter < segmentCount; indexAfter++) {
    if (canWallSegmentGetObjectType(warehouseConfiguration, type, side, indexAfter)) {
      return { index: indexAfter };
    }
  }
  for (let indexBefore = sourceIndex - 1; indexBefore >= 0; indexBefore--) {
    if (canWallSegmentGetObjectType(warehouseConfiguration, type, side, indexBefore)) {
      return { index: indexBefore };
    }
  }
  return false;
}

export const FixedSegmentObjects = [GLASS_ELEMENT, WALL_LIGHTBAND];

export function isFixedSegmentObject(type) {
  return FixedSegmentObjects.indexOf(type) !== -1;
}
